// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecruiterBenefits_wrapper__oVYUi","recruitAchievements":"RecruiterBenefits_recruitAchievements__9MvVf","title":"RecruiterBenefits_title__o4o5n"};